<template>
  <div class="row">
    <div class="col-md-12">
      <div class="box box-primary">
        <div class="overlay" v-if="loadingStatsMembres">
          <i class="fa fa-refresh fa-spin"></i>
        </div>
        <div class="box-header with-border">
          <h3 class="box-title">Statistiques générales pour les membres (membre affilié au moins un jour durant l'année concernée)
          </h3>
          <button class="btn btn-default btn-xs pull-right"
                  @click.prevent="getStatsMembres(true)">
            <i class="fa fa-refresh "></i>
          </button>
        </div>
        <div class="box-body">
          <table class="table table-hover stats-table">
            <thead>
            <tr>
              <th class="col-annee">Année</th>
              <th v-b-tooltip.hover.top title="Chiffre interne en constante évolution">
                <span class="stat-title">Membres affiliés</span>
                <small class="stat-help">Chiffre interne <i class="fa fa-info-circle"></i></small>
              </th>
              <th v-b-tooltip.hover.top title="Sans les membres licenciés dans les clubs non-licenciés et sans les licences administratives, actifs au moins un jour dans l'année x et dont la demande est entrée avant le 31-01-(x+1)">
                <span class="stat-title">ADEPS</span>
                <small class="stat-help">Subvention ADEPS <i class="fa fa-info-circle"></i></small>
              </th>
              <th v-b-tooltip.hover.top title="Nombre de membres dont la demande de licence a été reçue avant le 31-01-(x+1) et dont la date de début a lieu durant l'année X">
                <span class="stat-title">ARENA</span>
                <small class="stat-help">Assurance ARENA <i class="fa fa-info-circle"></i></small>
              </th>
              <th v-b-tooltip.hover.top title="Licences dont la date de début se situe durant l'année">
                <span class="stat-title">Licences activées</span>
                <small class="stat-help">Date de début dans l'année <i class="fa fa-info-circle"></i></small>
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="stat in orderedByYear(statsMembres)" :key="stat.annee">
              <td class="col-annee"><strong>{{ stat.annee }}</strong></td>
              <td><span class="stat-value">{{ stat.nombre }}</span> <span class="stat-unit">membres</span></td>
              <td><span class="stat-value">{{ stat.ADEPS }}</span> <span class="stat-unit">membres</span></td>
              <td><span class="stat-value">{{ stat.ARENA }}</span> <span class="stat-unit">membres</span></td>
              <td><span class="stat-value">{{ stat.nombreLicences }}</span> <span class="stat-unit">licences</span></td>
            </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="5" class="text-muted stats-footnote"><i class="fa fa-info-circle"></i> Procédure de calcul modifiée à partir de 2023.</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>


    <div class="col-md-6">
      <div class="box box-primary">
        <div class="overlay" v-if="loadingStatsClubs">
          <i class="fa fa-refresh fa-spin"></i>
        </div>
        <div class="box-header with-border">
          <h3 class="box-title">Statistiques générales pour les clubs</h3>
          <button class="btn btn-default btn-xs pull-right"
                  @click.prevent="getStatsClub(true)">
            <i class="fa fa-refresh "></i>
          </button>
        </div>
        <div class="box-body">
          <table class="table table-hover stats-table">
            <thead>
            <tr>
              <th class="col-annee">Année</th>
              <th>
                <span class="stat-title">Clubs affiliés</span>
                <small class="stat-help">Nombre total par année</small>
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="stat in orderedByYear(statsClubs)" :key="stat.annee">
              <td class="col-annee"><strong>{{ stat.annee }}</strong></td>
              <td><span class="stat-value">{{ stat.somme }}</span> <span class="stat-unit">clubs</span></td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>


    <div class="col-md-6">
      <div class="box box-primary">
        <div class="overlay" v-if="loadingStatsMembresAge">
          <i class="fa fa-refresh fa-spin"></i>
        </div>
        <div class="box-header with-border">
          <h3 class="box-title">Statistiques générales pour les membres (sans compter membres affiliés aux clubs non-affiliés)
          </h3>
          <button class="btn btn-default btn-xs pull-right"
                  @click.prevent="getStatsMembresAge(true)">
            <i class="fa fa-refresh "></i>
          </button>
        </div>
        <div class="box-body">
          <table class="table table-hover stats-table">
            <thead>
            <tr>
              <th class="col-annee">Année</th>
              <th><span class="stat-title">-8 ans</span></th>
              <th><span class="stat-title">8-10</span></th>
              <th><span class="stat-title">11-13</span></th>
              <th><span class="stat-title">14-17</span></th>
              <th><span class="stat-title">18-35</span></th>
              <th><span class="stat-title">35+</span></th>
              <th><span class="stat-title">Total</span></th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="statsMembresAge && statsMembresAge[annee]"
                v-for="annee in getAnnees().reverse()" :key="annee">
              <td class="col-annee"><strong>{{ annee }}</strong></td>
              <td><span class="stat-value">{{ statsMembresAge[annee][2]["0-7"] }}</span></td>
              <td><span class="stat-value">{{ statsMembresAge[annee][2]["8-10"] }}</span></td>
              <td><span class="stat-value">{{ statsMembresAge[annee][2]["11-13"] }}</span></td>
              <td><span class="stat-value">{{ statsMembresAge[annee][2]["14-17"] }}</span></td>
              <td><span class="stat-value">{{ statsMembresAge[annee][2]["18-35"] }}</span></td>
              <td><span class="stat-value">{{ statsMembresAge[annee][2]["36-120"] }}</span></td>
              <td><span class="stat-value stat-total">{{ getTotal(statsMembresAge[annee][2]) }}</span></td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <div class="box box-primary">
        <div class="overlay" v-if="loadingStatsMembresDropout">
          <i class="fa fa-refresh fa-spin"></i>
        </div>
        <div class="box-header with-border">
          <h3 class="box-title">Statistiques générales du dropout
          </h3>
          <button class="btn btn-default btn-xs pull-right"
                  @click.prevent="getStatsMembresDropout(true)">
            <i class="fa fa-refresh "></i>
          </button>
        </div>
        <div class="box-body">
          <table class="table table-hover stats-table">
            <thead>
            <tr>
              <th class="col-annee" rowspan="2">Année</th>
              <th rowspan="2">
                <span class="stat-title">Nouveaux affiliés</span>
                <small class="stat-help">Année de référence</small>
              </th>
              <th :colspan="getAnnees().length" class="text-center stats-group-header">Rétention - Nouveaux affiliés de [ligne] restants en [colonne]</th>
            </tr>
            <tr>
              <th v-for="annee in getAnnees()" :key="'h-' + annee" class="text-center col-year-small">{{ annee }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="statsMembresDropout && statsMembresDropout[annee]"
                v-for="annee in getAnnees()">
              <td>{{annee}}</td>
              <td>{{statsMembresDropout[annee]["count_nouveaux"]}}</td>
              <td :bgcolor="annee>=annee2 ? '#c0c0c0':'white'" v-for="annee2 in getAnnees()">
                <template v-if="annee>=annee2"></template>
                <template v-if="annee<annee2">
                  <span
                    :id="annee+'_'+annee2"
                    v-b-tooltip.hover
                    placement="bottom"
                    :title="statsMembresDropout[annee2]['dropout'][annee] + ' restants en '+annee2+' des nouveaux affiliés de '+annee+
                     '\n('+((100 - (statsMembresDropout[annee2]['dropout'][annee] * 100 / statsMembresDropout[annee]['count_nouveaux'])) * -1).toFixed(2)+'%)'"
                  >
                    {{statsMembresDropout[annee2]["dropout"][annee]}}
                  </span >
                  </template>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

  </div>
</template>


<script>
import {mapGetters, mapActions} from 'vuex'

var moment = require('moment')

export default {
  data() {
    return {
      statsClubs: null,
      loadingStatsClubs: false,

      statsMembres: null,
      loadingStatsMembres: false,

      statsMembresAge: null,
      loadingStatsMembresAge: false,

      statsMembresDropout: null,
      loadingStatsMembresDropout: false,
    }
  },
  props: {},
  computed: {
    ...mapGetters({
      getRoute: 'getRoute',
    }),

  },
  mounted: function () {
    this.getStatsClub()
    this.getStatsMembres()
    this.getStatsMembresAge()
    this.getStatsMembresDropout()
  },
  methods: {
    ...mapActions({
      setRecap: 'setRecap',
    }),
    getTotal: function (obj) {
      return _.reduce(obj, function (memo, item) {
        return memo + item;
      })
    },
    getAnnees: function () {
      let retour = [];
      for (let i = 2007; i <= moment().year(); i++) {
        retour.push(i)
      }
      return retour;
    },
    orderedByYear: function (obj) {
      return _.sortBy(obj, 'annee').reverse()
    },
    getStatsClub: function (force = false) {
      let self = this;
      this.loadingStatsClubs = true
      self.$http.post(this.getRoute('Statistiques.statistiquesGeneralesClubs'), {forceCache: force}).then((response) => {
        this.statsClubs = response.body
        this.loadingStatsClubs = false
      }, (response) => {
      });
    },
    getStatsMembres: function (force = false) {
      let self = this;
      this.loadingStatsMembres = true
      self.$http.post(this.getRoute('Statistiques.statistiquesGeneralesMembres'), {forceCache: force}).then((response) => {
        this.statsMembres = response.body
        this.loadingStatsMembres = false
      }, (response) => {
      });
    },
    getStatsMembresAge: function (force = false) {
      let self = this;
      this.loadingStatsMembresAge = true
      self.$http.post(this.getRoute('Statistiques.statistiquesMemberByAgeByYear'), {forceCache: force}).then((response) => {
        this.statsMembresAge = response.body
        this.loadingStatsMembresAge = false
      }, (response) => {
      });
    },
    getStatsMembresDropout: function (force = false) {
      let self = this;
      this.loadingStatsMembresDropout = true
      self.$http.post(this.getRoute('Statistiques.getDropout'), {forceCache: force}).then((response) => {
        this.statsMembresDropout = response.body
        this.loadingStatsMembresDropout = false
      }, (response) => {
      });
    }
  },
  beforeRouteUpdate(to, from, next) {
  },
  beforeRouteEnter(to, from, next) {
  },
  watch: {},
  components: {}
}
</script>



// WEBPACK FOOTER //
// src/components/Secretariat/Statistiques/General/General_abft.vue